<template>
  <div class="work-info">
    <h1>{{ title }}</h1>
    <p>{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  props: ['title', 'subtitle'],
  data() {
    return {
    };
  },
  computed: {

  },
};
</script>

<style lang="scss" scoped>
.work-info {
  background: #fff;
  box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.2);
  display: inline-block;
  margin-top: 24px;
  padding: 6px 12px;
  text-align: left;
  transform: scale(1);
  transition: all 0.3s;

  // &:hover {
  //   box-shadow: 0px 3px 9px 0px rgba(0,0,0,0.1);
  //   transform: scale(1.03);
  //   transition: all 0.6s;
  // }
}

h1 {
  font-size: 14px;
  margin: 0;
}

p {
  font-size: 12px;
  margin: 0;
}
</style>



/** WEBPACK FOOTER **
 ** WorkInfo.vue?b3217e36
 **/